function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextInput } from "@brandwatch/axiom-components";
import { translate } from "@brandwatch/axiom-localization";
const t = translate({
  "Enter current password": {
    de: "Bisheriges Passwort eingeben",
    es: "Ingresar contraseña actual",
    fr: "Entrez votre mot de passe"
  }
});
export default class CurrentPasswordInput extends Component {
  render() {
    const {
      axiomLanguage
    } = this.context;
    const {
      invalid,
      value,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(TextInput, _extends({}, rest, {
      invalid: invalid,
      label: t("Enter current password", axiomLanguage),
      required: true,
      space: "x8",
      type: "password",
      value: value
    }));
  }

}

_defineProperty(CurrentPasswordInput, "contextTypes", {
  axiomLanguage: PropTypes.string
});